import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, connect } from 'react-redux'
import { TableComp } from 'sz-react-utils-lite'
import { Modal, Popconfirm, Select, Tooltip, Icon, Button, notification } from 'antd'
import {
  agentCommissionApprovedByManagerFxn, agentCommissionVerifyByManagerFxn,
  allAgentCommissionListFxn, sendVerifyAgentCommOtpFxn
} from '../actions'
import {
  displayDate, getSemesterList, longDisplayDate
} from '../../../components/_utils/appUtils'
import { listAllCountries } from '../../countries/actions/countries'
import { listAllUniversities } from '../../university/actions/university'
import { getUrlPushWrapper } from '../../../routes/routes'
import { getBranchManagerAgentList } from '../../users/actions/user'
import AgentCommStudentDrawer from '../drawers/agentCommStudent'
import EditAgentInvoiceComponent from '../RaiseAgentInvoice/EditAgentInvoiceDrawer'
import BonusDetailsDrawer from '../drawers/bonusDetailsDrawer'

const { Option } = Select

let initState = {
  status: '',
  visible: false,
  commissionId: ''
}
let initFilter = {
  countryId: '',
  status: '',
  universityId: '',
  intake: '',
  countryList: [],
  universityList: [],
  agentList: [],
  courseName: '',
  semester: ''
}
let agentCommissionInit = {
  visible: false,
  record: {}
}
let raiseInvoiceInit = {
  visible: false,
  record: {}
}
const AgentCommissionList = (props) => {
  let { currentUser } = props
  let [totalRecord, setTotalRecord] = useState(0)
  const [state, setState] = useState(initState)
  const [filterState, setFilterState] = useState(initFilter)
  const [tableSearch, setTableSearch] = useState(false)
  const [agentCommissionState, setAgentCommissionState] = useState(agentCommissionInit)
  const [raiseInvoiceState, setRaiseInvoiceState] = useState(raiseInvoiceInit)
  const [bonusDetails, setBonusDetails] = useState({
    bonus: {}, visible: false
  })
  const [visibleVerifyModal, setVisibleVerifyModal] = useState({
    visible: false,
    record: {}
  })
  const [otp, setOtp] = useState(['', '', '', ''])

  const tableRef = useRef()
  const dispatch = useDispatch()
  useEffect(() => {
    loadData.loadCountryList()
  }, [])
  const apiRequest = (params) => {
    return new Promise(async (resolve) => {
      let resp = await events.getParamsForApplicationList()
      if (resp.intake) {
        resp['intake.month'] = resp.intake
        delete resp['intake']
      }
      if (resp.intakeYear) {
        resp['intake.year'] = resp.intakeYear
        delete resp['intakeYear']
      }
      params = { ...params, ...resp }
      params.transactionType = 'Credit'
      params.sortField = '_id'
      params.sortOrder = 'descend'
      params.countryId = currentUser.countryId
      params.referToManager = 'Pending'

      let respData = await dispatch(allAgentCommissionListFxn({
        ...params,
        regExFilters: ['semester', 'courseName', 'name']
      }))
      setTotalRecord(respData.total)
      resolve(respData)
    })
  }
  const reload = () => {
    if (tableRef && tableRef.current) {
      tableRef.current.reload()
    }
  }

  const events = {

    updateLocalFilter: (data) => {
      try {
        setFilterState({
          ...filterState,
          ...data
        })
      } catch (e) {
      }
    },
    closeDrawer: () => {
      setState({
        ...initState
      })
    },
    getParamsForApplicationList: () => {
      return new Promise((resolve) => {
        let searchParams = new URLSearchParams(window.location.search)
        let countryId = searchParams.get('countryId')
        let agentId = searchParams.get('agentId')
        let universityId = searchParams.get('universityId')
        let name = searchParams.get('name')
        let courseName = searchParams.get('courseName')
        let intake = searchParams.get('intake')
        let semester = searchParams.get('semester')
        let status = searchParams.get('status')
        let intakeYear = searchParams.get('intakeYear')
        let obj = {}
        if (agentId) {
          obj.agentId = agentId
        }
        if (countryId) {
          obj.countryId = countryId
        }
        if (universityId) {
          obj.universityId = universityId
        }
        if (name) {
          obj.name = name
        }
        if (courseName) {
          obj.courseName = courseName
        }
        if (intake) {
          obj.intake = intake
        }
        if (intakeYear) {
          obj.intakeYear = intakeYear
        }
        if (status) {
          obj.status = status
        }
        if (semester) {
          obj.semester = semester
        }
        resolve(obj)
      })
    },
    searchFxn: async () => {
      let obj = {}
      let {
        countryId,
        universityId,
        name,
        courseName,
        agentId,
        intake,
        intakeYear,
        semester,
        status
      } = filterState
      if (countryId) {
        obj.countryId = countryId
      }

      if (name) {
        obj.name = name
      }
      if (courseName) {
        obj.courseName = courseName
      }
      if (universityId) {
        obj.universityId = universityId
      }
      if (agentId) {
        obj.agentId = agentId
      }
      if (semester) {
        obj.semester = semester
      }
      if (status) {
        obj.status = status
      }
      if (intake) {
        obj.intake = intake
      }
      if (intakeYear) {
        obj.intakeYear = intakeYear
      }
      dispatch(
        getUrlPushWrapper('referredAgentCommission', {
          ...obj
        }))
      setTableSearch(true)
      setTimeout(() => {
        reload()
      }, 200)
    },
    clearFxn: async () => {
      let obj = {}
      events.updateLocalFilter({
        countryId: '',
        universityId: '',
        name: '',
        intake: '',
        agentId: '',
        courseName: '',
        semester: '',
        intakeYear: '',
        status: ''
      })
      dispatch(
        getUrlPushWrapper('referredAgentCommission', {
          ...obj
        }))
      setTableSearch(true)
      setTimeout(() => {
        reload()
      }, 200)
    },
    showAgentCommissionDrawer: (record) => {
      record.agentCommissionId = record._id
      setAgentCommissionState({
        visible: true,
        record: record
      })
    },
    hideAgentCommissionDrawer: () => {
      setAgentCommissionState({
        visible: false,
        record: {}
      })
    },

    commissionVerified: async (record) => {
      let { data, success } = await dispatch(agentCommissionApprovedByManagerFxn({ record }))
      if (success) {
        reload()
      }
    },
    showRaiseInvoiceState: (record) => {
      setRaiseInvoiceState({
        visible: true,
        record: record
      })
    },
    hideRaiseInvoiceState: () => {
      setRaiseInvoiceState({
        visible: false,
        record: {}
      })
      reload()
    },
    showBonusDetails: (data) => {
      setBonusDetails({
        bonus: data,
        visible: true
      })
    },
    hideBonusDetails: () => {
      setBonusDetails({
        bonus: {},
        visible: false
      })
    }
  }

  const loadData = {
    loadCountryList: async () => {
      let params = {
        results: 5000,
        select: ['countryName'],
        sortField: 'countryName',
        sortOrder: 'ascend'
      }
      let { data } = await dispatch(listAllCountries(params))
      let agentResp = await dispatch(getBranchManagerAgentList())
      let obj = {}
      if (data && data.length) {
        obj.countryList = data
      }
      if (agentResp && agentResp.data && agentResp.data.length) {
        obj.agentList = agentResp.data
      }
      events.updateLocalFilter({ ...obj })
    },
    loadUniversityNameList: async (countryId) => {
      let params = {
        results: 5000,
        select: ['universityName'],
        sortField: 'universityName',
        sortOrder: 'ascend',
        regExFilters: ['universityName'],
        showUniversity: [true, false],
        universityCountry: countryId
      }
      let { data } = await dispatch(listAllUniversities(params))
      let obj = {
        universityId: ''
      }
      if (data && data.length) {
        obj.universityList = data
      }
      events.updateLocalFilter({ ...obj, countryId })
    }
  }


  const columns = [
    {
      title: 'Sr .no',
      key: '_id',
      dataIndex: '_id',
      width: 50,
      render: (item, record, index) => {
        return (
          <div style={{ width: 50 }}>
            {index + 1}
          </div>
        )
      }
    },
    {
      title: 'Date',
      dataIndex: 'invoiceDate',
      key: 'invoiceDate',
      width: 80,
      render: (item, record) => {
        return (
          <div style={{ width: 100 }}>
            {item ? displayDate(item) : ''}
          </div>
        )
      }
    },
    {
      title: 'Agent',
      key: 'agentId',
      dataIndex: 'agentId',
      width: 220,
      render: (item, record) => {
        return (
          <div style={{ width: 180 }}>
            {item && item.name ? item.name : null}
            {item && item.companyName ? `(${item.companyName})` : null}
          </div>
        )
      }
    },


    {
      title: 'Agent Share',
      dataIndex: 'totalCommission',
      key: 'totalCommission',
      width: 100,
      render: (item, record) => {
        let { totalApprovedByAdminCommission, countryId } = record
        return (
          <div style={{ width: 90 }}>
            {countryId && countryId.currency ? countryId.currency : ''}
            {totalApprovedByAdminCommission ? totalApprovedByAdminCommission : item} &nbsp;
            {countryId && countryId.currencyName ? countryId.currencyName : ''}
          </div>
        )
      }
    },

    {
      title: 'Status',
      dataIndex: 'invoiceStatus',
      key: 'invoiceStatus',
      width: 100,
      render: (item, record) => {
        return (
          <div style={{ width: 100 }}>
            {item == 'Approved' ?
              <label className={'label label-success'}>Approved</label> :
              <label className={'label label-danger'}>Pending</label>}
          </div>
        )
      }
    },

    {
      title: 'Added By',
      key: 'userId',
      dataIndex: 'userId',
      width: 160,
      render: (item, record) => {
        return (
          <div style={{ width: 160 }}>
            <div className={'colorPrimary font12 textCap'}>
              {item && item.name ? item.name : null}
            </div>
            <div>{longDisplayDate(record.createdAt)}</div>
          </div>
        )
      }
    },
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
      width: 100
    },
    {
      title: 'Action',
      key: 'action',
      dataIndex: 'action',
      width: 160,
      render: (item, record) => {
        let { referToManager, invoiceStatus, transactionType, type } = record
        return (
          <div className={'btn_group_row'}>

            {type == 'Bonus' ? <>
              <Tooltip title={'View Details'}>
                <a className='btn btn-default roundNew' onClick={() => {
                  events.showBonusDetails(record)
                }}>
                  <img src='../uniBtn/eye.png' alt='' className={'eyeBtn'} /> View
                </a>
              </Tooltip>
            </> : null}

            {type !== 'Bonus' ? <>
              <Tooltip title={'View Student List'}>
                <a className='btn btn-default roundNew' onClick={() => {
                  events.showAgentCommissionDrawer(record)
                }}>
                  <img src='../uniBtn/eye.png' alt='' className={'eyeBtn'} /> View
                </a>
              </Tooltip>

              {(invoiceStatus == 'Pending' && transactionType == 'Credit') ?
                <>
                  <a className='btn btn-default roundNew'
                     onClick={() => {
                       events.showRaiseInvoiceState(record)
                     }}><img src='/dist/img/edit.svg' alt='edit' style={{ height: 12 }} /> Edit
                  </a>
                </> : ''}
            </> : null}


            {referToManager === 'Pending' && (
              <a className={'btn btn-success roundNew'} onClick={() => {
                showModal(record)
              }}>
                Verify & Approve Now
              </a>
            )}
          </div>
        )
      }
    }
  ]

  const showModal = async (record) => {
    let response = await dispatch(sendVerifyAgentCommOtpFxn({ userId: currentUser._id }))
    if (response) {
      setVisibleVerifyModal({
        visible: true,
        record: record
      })
    }
  }

  const handleOk = async (record) => {
    const enteredOtp = otp.join('')
    if (!enteredOtp) {
      notification.warning({
        message: 'Please Enter Otp'
      })
    }
    record.otp = enteredOtp
    let { success } = await dispatch(agentCommissionVerifyByManagerFxn(record))
    if (success) {
      reload()
      setVisibleVerifyModal({
        visible: false,
        record: {}
      })
      setOtp(['', '', '', ''])
    }
  }
  const handleCancel = () => setVisibleVerifyModal({
    visible: false,
    record: {}
  })
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return

    let newOtp = [...otp]
    newOtp[index] = element.value
    setOtp(newOtp)

    if (element.nextSibling) {
      element.nextSibling.focus()
    }
  }
  return (
    <div className='row mt-4'>
      <div className='col-lg-12'>
        <div className='card'>
          <div className='table-head d-flex align-items-center'>
            <h5>All Refer Commission: {totalRecord || 0}</h5>
            <div className='sort-box-table mark-btn mark-btn40'>

            </div>
          </div>
          <div className='card-body table-responsive'>

            <div className='card-body table-responsive'>
              <TableComp columns={columns}
                         apiRequest={apiRequest}
                         pagination={{
                           position: 'top',
                           pageSizeOptions: ['50', '100', '200', '500'],
                           defaultPageSize: 50
                         }}
                         ref={tableRef}
              />
            </div>
          </div>
        </div>
      </div>


      {agentCommissionState.visible ?
        <AgentCommStudentDrawer
          visible={agentCommissionState.visible}
          onClose={events.hideAgentCommissionDrawer}
          onSubmit={reload}
          record={agentCommissionState.record}
        /> : null}

      {raiseInvoiceState.visible ?
        <EditAgentInvoiceComponent
          visible={raiseInvoiceState.visible}
          onClose={events.hideRaiseInvoiceState}
          onSubmit={reload}
          record={raiseInvoiceState.record}
        /> : null}


      {bonusDetails.visible ?
        <BonusDetailsDrawer
          {...bonusDetails}
          onClose={events.hideBonusDetails}
        /> : null}

      {visibleVerifyModal.visible ? <Modal
        title={
          <span>
            Confirm Commission Verification & Approval
          </span>
        }
        width={650}
        visible={visibleVerifyModal.visible}
        onCancel={handleCancel}
        okText={''}
        cancelText={''}
        footer={null}
      >

        <div
          className='otp-container'>
          <h2 className={'blueHeading2 contract-blue-color'}>OTP Verification</h2>
          <p style={{ fontSize: '18px', color: '#d48806', marginBottom: '10px' }}>
            ⚠️ It is your responsibility to ensure the commission is accurately approved.
            Any excess amount granted will be deducted from your salary.
          </p>
          <p style={{ fontSize: '18px' }}>Enter the verification code we sent
            to <strong>{currentUser.email} {currentUser.mobile ? `& ${currentUser.mobile}` : ''}</strong></p>

          <div className=' d-flex flex-column'>
            <p style={{ fontSize: '18px' }}>Type your OTP here</p>
            <div className={'otp-inputs'}>
              {otp.map((data, index) => (
                <input
                  key={index}
                  type='text'
                  maxLength='1'
                  value={data}
                  onChange={e => handleChange(e.target, index)}
                  onFocus={e => e.target.select()}
                />
              ))}
            </div>
          </div>


          <p style={{ fontSize: '18px' }} className='resend-text'>
            Didn’t receive the OTP?
            <span className='resend-link'
                  onClick={() => {
                    showModal(visibleVerifyModal.record)
                  }}
            > Resend OTP</span>
          </p>
          <button className='btn btn-primary'
                  onClick={() => {
                    handleOk(visibleVerifyModal.record)
                  }}>Approve Now
          </button>
        </div>
      </Modal> : null}
    </div>
  )
}

const mapStateToProps = ({ global, router }) => ({ currentUser: global.currentUser })
const mapDispatchToProps = dispatch => {
  return { dispatch }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AgentCommissionList)
